import type { SVGProps } from 'react'
const SvgSyWarning = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M.8 21.2 12 1.7l11.3 19.5zM12 18.1c.3 0 .5 0 .7-.3.2-.2.3-.4.3-.7s0-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5 0-.7.3-.3.4-.3.7 0 .5.3.7c.2.2.4.3.7.3m-1-3h2.1V10H11z" />
	</svg>
)
export default SvgSyWarning
